/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/scandipwa
 */

import CurrencySwitcher from 'Component/CurrencySwitcher';
import Link from 'Component/Link';
import SourceMenu from 'SourceComponent/Menu/Menu.component';
import { getSortedItems } from 'Util/Menu';

/** @namespace Pwa/Component/Menu/Component */
export class Menu extends SourceMenu {
    renderAdditionalInformation(checkMobile = false) {
        const { device } = this.props;

        if (checkMobile && !device.isMobile) {
            return null;
        }

        return (
            <>
                { this.renderCurrencySwitcher() }
                { this.renderStoreSwitcher() }
            </>
        );
    }

    renderCurrencySwitcher() {
        const { device } = this.props;

        if (!device.isMobile) {
            return null;
        }

        return <CurrencySwitcher />;
    }

    renderSubMenuDesktopItems = (item) => {
        const { item_id, children } = item;

        if (!Object.keys(children).length) {
            return null;
        }

        const { activeMenuItemsStack, closeMenu } = this.props;
        const isVisible = activeMenuItemsStack.includes(item_id);

        if (!isVisible) {
            return null;
        }

        return (
            <div
              block="Menu"
              elem="SubCategoriesWrapper"
              mods={ { isVisible } }
              key={ item_id }
            >
                <div
                  block="Menu"
                  elem="SubCategoriesWrapperInner"
                  mods={ { isVisible } }
                >
                    <div block="Menu" elem="SubCategories">
                        { this.renderSubLevel(item) }
                    </div>
                    { this.renderAdditionalInformation() }
                </div>
                <div
                  block="Menu"
                  elem="Overlay"
                  mods={ { isVisible } }
                  onMouseEnter={ closeMenu }
                />
            </div>
        );
    };

    renderSeeAll = (url) => (
            <Link to={ url } mix={ { block: 'Button', mods: { isHollow: true } } }>
                { __('All') }
            </Link>
    );

    renderSubLevel(category, isSecondLevel = false) {
        const { activeMenuItemsStack } = this.props;
        const {
            item_id,
            children,
            url: { pathname = '' }
        } = category;
        const childrenArray = getSortedItems(Object.values(children));
        const isVisible = activeMenuItemsStack.includes(item_id);
        const subcategoryMods = { type: 'subcategory' };

        return (
            <div block="Menu" elem="SubMenu" mods={ { isVisible } } key={ item_id }>
                <div block="Menu" elem="ItemList" mods={ { ...subcategoryMods } }>
                    { childrenArray.map((item) => this.renderSubLevelItems(item, isSecondLevel)) }
                    { this.renderSeeAll(pathname) }
                </div>
            </div>
        );
    }
}

export default Menu;
